import React from 'react';
import withIcon from '../utilities/withIcon';

const IconXCircle = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm6.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0zm-3.318-3.182a.75.75 0 0 1 0 1.06L9.061 8l2.121 2.121a.75.75 0 0 1-1.06 1.061L8 9.061l-2.121 2.121a.75.75 0 0 1-1.061-1.06L6.939 8 4.818 5.879a.75.75 0 0 1 1.06-1.061L8 6.939l2.121-2.121a.75.75 0 0 1 1.061 0z" />
    </g>
  );
};

export default withIcon(IconXCircle);
